import type { BodyStyle } from '~/contracts/common';

const homeFeedBodyStyles: BodyStyle[] = [
  {
    alt: 'SUVs',
    bodyStyleInCvnaid: 'Suv',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/suv.png`,
    link: '/cars/suv',
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/suv.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/suv.png?width=150`
  },
  {
    alt: 'Sedans',
    bodyStyleInCvnaid: 'Sedan',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/sedan.png`,
    link: '/cars/sedan',
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/sedan.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/sedan.png?width=150`
  },
  {
    alt: 'Trucks',
    bodyStyleInCvnaid: 'Pickup',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/truck.png`,
    link: '/cars/truck',
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/truck.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/truck.png?width=150`
  },
  {
    alt: 'EVs',
    fuelTypeInCvnaid: 'Electric',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/electric.png`,
    link: '/cars/electric',
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/electric.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/electric.png?width=150`
  },
  {
    alt: 'Hybrids',
    fuelTypeInCvnaid: 'Hybrid',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/hybrid.png`,
    link: '/cars/hybrid',
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/hybrid.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/hybrid.png?width=150`
  },
  {
    alt: 'Coupes',
    bodyStyleInCvnaid: 'Coupe',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/coupe.png`,
    link: '/cars/coupe',
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/coupe.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/coupe.png?width=150`
  },
  {
    alt: 'Hatchbacks',
    bodyStyleInCvnaid: 'Hatchback',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/hatchback.png`,
    link: '/cars/hatchback',
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/hatchback.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/hatchback.png?width=150`
  },
  {
    alt: 'Wagons',
    bodyStyleInCvnaid: 'Wagon',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/wagon.png`,
    link: '/cars/wagon',
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/wagon.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/wagon.png?width=150`
  },
  {
    alt: 'Convertibles',
    bodyStyleInCvnaid: 'Convertible',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/convertible.png`,
    link: '/cars/convertible',
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/convertible.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/convertible.png?width=150`
  },
  {
    alt: 'Minivans',
    bodyStyleInCvnaid: 'MiniVan',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/minivan.png`,
    link: '/cars/minivan',
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/minivan.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/minivan.png?width=150`
  },
  {
    alt: 'Plug-in Hybrids',
    fuelTypeInCvnaid: 'Plug-In Hybrid',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/plug-in-hybrid.png`,
    link: '/cars/plugin-hybrid',
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/plug-in-hybrid.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/plug-in-hybrid.png?width=150`
  }
];

export default homeFeedBodyStyles;
